import React from "react"
import Icon from "../../Icon/Icon"
import ReactTooltip from "react-tooltip"
import Button from "../../Button/Button"
import {useModal} from "react-modal-hook"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"
import {JWTProviders} from "../../../resources/orgSettings"
import * as Yup from "yup"
import TextField from "../TextField/TextField"

const jwksPathSchema = Yup.string()
	.required("JWKS path is required")
	.matches(
		/^https:\/\/([A-Za-z0-9\-]+\.)+okta\.com\/oauth2\/[A-Za-z0-9]+\/v1\/keys$/,
		"Must be a valid Okta JWKS URL: 'https://{oktaDomain}/oauth2/{authorization_server_id}/v1/keys'"
	)

export default function OktaFields() {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={JWTProviders.Okta} />
	))

	return (
		<fieldset className="jwt-fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="https://your-domain.okta.com/oauth2/server-id/v1/keys"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</>
				}
			/>
			<TextField
				name="issuer"
				label="Issuer"
				placeholder=" "
				optional
				helpElements={
					<div data-tip="React-tooltip" data-for="issuer-info" className="tooltip-info">
						<Icon icon="information-circle--interface-essential" size={12} />
						<ReactTooltip className="tooltip-info" id="issuer-info" effect="solid">
							If you use a are using a custom domain, please provide the custom domain you chose for your authorization
							server.
						</ReactTooltip>
					</div>
				}
			/>
		</fieldset>
	)
}
